require('angular-module');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ./lib/angular.js
// module id = 68
// module chunks = 22 23